var React = require('react');

function ArrowStrokeLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.6603 1.66665L1.33398 15L14.6603 28.3333L18.5445 24.4471L11.8182 17.7488L31.334 17.7488L31.334 12.2512L11.8182 12.2512L18.5445 5.5529L14.6603 1.66665Z","stroke":"white"}));
}

ArrowStrokeLeft.defaultProps = {"width":"32","height":"30","viewBox":"0 0 32 30","fill":"none"};

module.exports = ArrowStrokeLeft;

ArrowStrokeLeft.default = ArrowStrokeLeft;
